import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import baseURL from "../../../../configs/api";
import { Button } from "@mui/material";
import axois from "../../../../configs/axois";
import { useTheme } from "../../../../components/hooks/useTheme";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import useAuth from "../../../../components/hooks/useAuth";
import colorConfigs from "../../../../configs/colorConfigs";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

export default function RentalTemplates() {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles, theme } = useTheme();
  const { handleTenantError }: any = useTenant();
  const { auth }: any = useAuth();
  const [logo, setLogo] = useState<string>("");
  const [logoObj, setLogoObj] = useState<any>();
  const [logoFirst, setLogoFirst] = useState<string>("");
  const [logoFirstObj, setLogoFirstObj] = useState<any>();
  const [logoSecond, setLogoSecond] = useState<string>("");
  const [logoSecondObj, setLogoSecondObj] = useState<any>();
  const [rentalInformation, setRentalInformation] = useState<string>("");
  const [rentalInformationInput, setRentalInformationInput] =
    useState<string>("Rental Information");
  const [rentalInformationObj, setRentalInformationObj] = useState<any>();
  const [rentalInformationSecond, setRentalInformationSecond] =
    useState<string>("");
  const [rentalInformationSecondInput, setRentalInformationSecondInput] =
    useState<string>("Rental Information");
  const [rentalInformationSecondObj, setRentalInformationSecondObj] =
    useState<any>();
  const [terms, setTerms] = useState<string>("");
  const [termsInput, setTermsInput] = useState<string>("Terms and Condition");
  const [termsObj, setTermsObj] = useState<any>();
  const [footer, setFooter] = useState<string>("");
  const [footerObj, setFooterObj] = useState<any>();
  const [vehicleInformation, setVehicleInformation] = useState<string>("");
  const [vehicleInformationInput, setVehicleInformationInput] =
    useState<string>("Vehicle Information");
  const [vehicleInformationObj, setVehicleInformationObj] = useState<any>();
  const [chargeInformation, setChargeInformation] = useState<string>("");
  const [chargeInformationInput, setChargeInformationInput] =
    useState<string>("Charge Information");
  const [chargeInformationObj, setChargeInformationObj] = useState<any>();
  const [signature, setSignature] = useState<string>("");
  const [signatureInput, setSignatureInput] = useState<string>("Signature");
  const [signatureObj, setSignatureObj] = useState<any>();

  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [getValue, setGetValue] = useState<boolean>(false);


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    if (rentalInformationObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: rentalInformationObj?.id,
            agreementName: rentalInformationInput,
            agreementNote: rentalInformation,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (rentalInformation || rentalInformationInput) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: rentalInformationInput,
              agreementNote: rentalInformation,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (rentalInformationSecondObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: rentalInformationSecondObj?.id,
            agreementName: rentalInformationInput,
            agreementNote: rentalInformation,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (rentalInformationSecond || rentalInformationSecondInput) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: rentalInformationInput,
              agreementNote: rentalInformation,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (termsObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: termsObj?.id,
            agreementName: termsInput,
            agreementNote: terms,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (terms || termsInput) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: termsInput,
              agreementNote: terms,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (vehicleInformationObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: vehicleInformationObj?.id,
            agreementName: vehicleInformationInput,
            agreementNote: vehicleInformation,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (vehicleInformation || vehicleInformationInput) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: vehicleInformationInput,
              agreementNote: vehicleInformation,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (chargeInformationObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: chargeInformationObj?.id,
            agreementName: chargeInformationInput,
            agreementNote: chargeInformation,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (chargeInformation || chargeInformationInput) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: chargeInformationInput,
              agreementNote: chargeInformation,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (signatureObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: signatureObj?.id,
            agreementName: signatureInput,
            agreementNote: signature,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (signature || signatureInput) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: signatureInput,
              agreementNote: signature,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (logoObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: logoObj?.id,
            agreementName: "Logo",
            agreementNote: logo,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (logo) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: "Logo",
              agreementNote: logo,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (logoFirstObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: logoFirstObj?.id,
            agreementName: "LogoFirst",
            agreementNote: logoFirst,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (logoFirst) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: "LogoFirst",
              agreementNote: logoFirst,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (logoSecondObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: logoSecondObj?.id,
            agreementName: "LogoSecond",
            agreementNote: logoSecond,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (logoSecond) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: "LogoSecond",
              agreementNote: logoSecond,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }

    if (footerObj) {
      await axios
        .put(
          `${baseURL}rentalAgreement?userId=${auth?.id}`,
          JSON.stringify({
            id: footerObj?.id,
            agreementName: "Footer",
            agreementNote: footer,
            createdDate: new Date(),
            createdByUserId: auth?.id || 0,
            updatedDate: new Date(),
            updatedByUserId: auth?.id || 0,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      if (footer) {
        await axios
          .post(
            `${baseURL}rentalAgreement?userId=${auth?.id}`,
            JSON.stringify({
              agreementName: "Footer",
              agreementNote: footer,
              createdDate: new Date(),
              createdByUserId: auth?.id || 0,
              updatedDate: new Date(),
              updatedByUserId: auth?.id || 0,
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    }
  };

  useEffect(() => {
    setPleaseWaitPopup(true);

    axois
      .get(`${baseURL}rentalAgreement`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setLogoObj(() =>
          response.data.find((item: any) => item.agreementName === "Logo")
        );
        setLogoFirstObj(() =>
          response.data.find((item: any) => item.agreementName === "LogoFirst")
        );
        setLogoSecondObj(() =>
          response.data.find((item: any) => item.agreementName === "LogoSecond")
        );
        setRentalInformationObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.agreementName !== "Logo" &&
                item.agreementName !== "LogoFirst" &&
                item.agreementName !== "LogoSecond" &&
                item.agreementName !== "Footer"
            )[5]
        );
        setRentalInformationSecondObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.agreementName !== "Logo" &&
                item.agreementName !== "LogoFirst" &&
                item.agreementName !== "LogoSecond" &&
                item.agreementName !== "Footer"
            )[4]
        );
        setTermsObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.agreementName !== "Logo" &&
                item.agreementName !== "LogoFirst" &&
                item.agreementName !== "LogoSecond" &&
                item.agreementName !== "Footer"
            )[3]
        );
        setVehicleInformationObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.agreementName !== "Logo" &&
                item.agreementName !== "LogoFirst" &&
                item.agreementName !== "LogoSecond" &&
                item.agreementName !== "Footer"
            )[2]
        );
        setChargeInformationObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.agreementName !== "Logo" &&
                item.agreementName !== "LogoFirst" &&
                item.agreementName !== "LogoSecond" &&
                item.agreementName !== "Footer"
            )[1]
        );
        setSignatureObj(
          () =>
            response.data.filter(
              (item: any) =>
                item.agreementName !== "Logo" &&
                item.agreementName !== "LogoFirst" &&
                item.agreementName !== "LogoSecond" &&
                item.agreementName !== "Footer"
            )[0]
        );
        setFooterObj(() =>
          response.data.find((item: any) => item.agreementName === "Footer")
        );

        setGetValue(true);
        handleTenantError(null);
      })
      .catch((error) => {
        console.error(error);
        handleTenantError(error);
      });

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pleaseWaitPopup && getValue) {
      setLogo(() => logoObj?.agreementNote);
      setLogoFirst(() => logoFirstObj?.agreementNote);
      setLogoSecond(() => logoSecondObj?.agreementNote);
      setRentalInformation(() => rentalInformationObj?.agreementNote);
      setRentalInformationInput(() => rentalInformationObj?.agreementName);
      setRentalInformationSecond(
        () => rentalInformationSecondObj?.agreementNote
      );
      setRentalInformationSecondInput(
        () => rentalInformationSecondObj?.agreementName
      );
      setTerms(() => termsObj?.agreementNote);
      setTermsInput(() => termsObj?.agreementName);
      setVehicleInformation(() => vehicleInformationObj?.agreementNote);
      setVehicleInformationInput(() => vehicleInformationObj?.agreementName);
      setChargeInformation(() => chargeInformationObj?.agreementNote);
      setChargeInformationInput(() => chargeInformationObj?.agreementName);
      setSignature(() => signatureObj?.agreementNote);
      setSignatureInput(() => signatureObj?.agreementName);
      setFooter(() => footerObj?.agreementNote);

      setPleaseWaitPopup(false);
      setGetValue(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pleaseWaitPopup, getValue]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--quill-text-color", themeStyles.form?.inputTextColor || "#1D2939");
    root.style.setProperty("--quill-bg-color", themeStyles.main?.mainBg || "#ffffff");
  }, [themeStyles]);

  return (
    <>
      <div
        className={`w-full flex flex-row px-[30px] py-[24px] ${themeStyles.main.tailwindMainBg}`}
      >
        <div className="w-full mr-[3%]">
          <h3
            className={`text-[12px] pb-0 m-0 ${themeStyles.main?.textHeadingColor}`}
          >
            Overview
          </h3>
          <hr />

          <form onSubmit={(e) => handleSubmit(e)}>
            <div className={`w-full h-[375px] flex flex-row p-4 gap-4 border border-dashed ${themeStyles.main?.borderColor}`}>
              <div className="w-[33%] h-[300px]">
                <div
                  className={`w-full h-[24px] border-dashed border-black border-[1px] text-xs ${themeStyles.main.textSubHeadingColor || "text-[#bdbdbd]"} align-middle`}
                >
                  Untitled
                </div>

                <div
                  className="quill-wrapper"
                  style={{
                    ...(theme === 'dark' && {
                      '--quill-text-color': '#ffffff',
                      '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                    }),
                  } as React.CSSProperties}
                >
                  <ReactQuill
                    className="custom-quill"
                    style={{ height: '225px' }}
                    theme="snow"
                    modules={modules}
                    value={logo}
                    onChange={setLogo}
                  />
                </div>
              </div>

              <div className="w-[33%] h-[300px]">
                <div
                  className={`w-full h-[24px] border-dashed border-black border-[1px] text-xs ${themeStyles.main.textSubHeadingColor || "text-[#bdbdbd]"} align-middle`}
                >
                  Untitled
                </div>

                <div
                  className="quill-wrapper"
                  style={{
                    ...(theme === 'dark' && {
                      '--quill-text-color': '#ffffff',
                      '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                    }),
                  } as React.CSSProperties}
                >
                  <ReactQuill
                    className="custom-quill"
                    style={{ height: '225px' }}
                    theme="snow"
                    modules={modules}
                    defaultValue={logoFirst}
                    value={logoFirst}
                    onChange={setLogoFirst}
                  />
                </div>
              </div>

              <div className="w-[33%] h-[300px]">
                <div
                  className={`w-full h-[24px] border-dashed border-black border-[1px] text-xs ${themeStyles.main.textSubHeadingColor || "text-[#bdbdbd]"} align-middle`}
                >
                  Untitled
                </div>

                <div
                  className="quill-wrapper"
                  style={{
                    ...(theme === 'dark' && {
                      '--quill-text-color': '#ffffff',
                      '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                    }),
                  } as React.CSSProperties}
                >
                  <ReactQuill
                    className="custom-quill"
                    style={{ height: "225px" }}
                    theme="snow"
                    modules={modules}
                    defaultValue={logoSecond}
                    value={logoSecond}
                    onChange={setLogoSecond}
                  />
                </div>
              </div>
            </div>

            <div
              className={`w-full flex flex-row justify-between gap-4 mt-[40px] p-4 pb-[80px] border border-dashed ${themeStyles.main?.borderColor}`}
            >
              <div className="w-1/2">
                <div>
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={rentalInformationInput}
                    onChange={(e) => setRentalInformationInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      modules={modules}
                      defaultValue={rentalInformation}
                      value={rentalInformation}
                      onChange={setRentalInformation}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={rentalInformationSecondInput}
                    onChange={(e) => setRentalInformationSecondInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      modules={modules}
                      defaultValue={rentalInformationSecond}
                      value={rentalInformationSecond}
                      onChange={setRentalInformationSecond}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={termsInput}
                    onChange={(e) => setTermsInput(e.target.value)}
                    required
                  />

                  <ReactQuill
                    className="custom-quill"
                    style={{ height: "225px" }}
                    theme="snow"
                    modules={modules}
                    defaultValue={terms}
                    value={terms}
                    onChange={setTerms}
                  />
                </div>
              </div>

              <div className="w-1/2">
                <div>
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={vehicleInformationInput}
                    onChange={(e) => setVehicleInformationInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      defaultValue={vehicleInformation}
                      value={vehicleInformation}
                      modules={modules}
                      onChange={setVehicleInformation}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={chargeInformationInput}
                    onChange={(e) => setChargeInformationInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      defaultValue={chargeInformation}
                      value={chargeInformation}
                      modules={modules}
                      onChange={setChargeInformation}
                    />
                  </div>
                </div>

                <div className="mt-[80px]">
                  <input
                    type="text"
                    className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={signatureInput}
                    onChange={(e) => setSignatureInput(e.target.value)}
                    required
                  />

                  <div
                    className="quill-wrapper"
                    style={{
                      ...(theme === 'dark' && {
                        '--quill-text-color': '#ffffff',
                        '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                      }),
                    } as React.CSSProperties}
                  >
                    <ReactQuill
                      className="custom-quill"
                      style={{ height: "225px" }}
                      theme="snow"
                      defaultValue={signature}
                      value={signature}
                      modules={modules}
                      onChange={setSignature}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`mt-[40px] p-4 pb-[56px] border border-dashed ${themeStyles.main?.borderColor}`}
            >
              <div
                className="quill-wrapper"
                style={{
                  ...(theme === 'dark' && {
                    '--quill-text-color': '#ffffff',
                    '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                  }),
                } as React.CSSProperties}
              >
                <ReactQuill
                  className="custom-quill"
                  style={{ height: "225px", width: "100%" }}
                  theme="snow"
                  defaultValue={footer}
                  value={footer}
                  modules={modules}
                  onChange={setFooter}
                />
              </div>
            </div>

            <div className="mt-[1.5rem]">
              <Button variant="contained"
                sx={{
                  backgroundColor: colorConfigs.btn.main.bg
                }}
                type="submit"
              >
                Save
              </Button>
            </div>

          </form>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  );
}
